import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Flex, Text, Box } from "samba-ui";
import { components } from "react-select";

export const countryOptions = [
  { label: "US", value: "US" },
  { label: "GB", value: "GB" },
  { label: "DE", value: "DE" },
  { label: "AU", value: "AU" },
  { label: "IT", value: "IT" },
  { label: "CA", value: "CA" },
  { label: "ES", value: "ES" },
  { label: "FR", value: "FR" },
  { label: "IN", value: "IN" },
  { label: "BR", value: "BR" },
  { label: "MX", value: "MX" },
];

const Option = ({ data, ...props }) => {
  return (
    <Box>
      <components.Option {...props}>
        <Flex width={60} alignItems="center" justifyContent="space-between">
          <i className={`flag-icon flag-icon-${data.label.toLowerCase()}`} />
          <Text>{data.label}</Text>
        </Flex>
      </components.Option>
    </Box>
  );
};

Option.propTypes = { data: PropTypes.object };

const SingleValue = ({ children, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <Flex width={60} alignItems="center" justifyContent="space-between">
        <i className={`flag-icon flag-icon-${children.toLowerCase()}`} />
        <Text>{children}</Text>
      </Flex>
    </components.SingleValue>
  );
};

SingleValue.propTypes = { children: PropTypes.node };

const CountrySelection = ({ selectedCountry, setSelectedCountry }) => {
  return (
    <Flex justifyContent="center" alignItems="center" bg="white" p={2}>
      <Box width={120} display="inline-block">
        <Dropdown
          options={countryOptions}
          placeholder="Pick a country..."
          selected={selectedCountry}
          onSelect={setSelectedCountry}
          components={{ SingleValue, Option }}
        />
      </Box>
    </Flex>
  );
};

CountrySelection.propTypes = {
  selectedCountry: PropTypes.object,
  setSelectedCountry: PropTypes.func,
};

export default CountrySelection;
